import { GET_ROLES_FAILURE, GET_ROLES_REQUEST, GET_ROLES_SUCCESS } from "redux/actions/action-type";

const initalState = {
    getRolesResponse: [],
    isGetRolesError: false,
    isGetRolesSuccess: false,
    isGetRolesLoading: false,
};

const rolesReducer = (state = initalState, { type, getRolesResponse }) => {
    switch (type) {
        case GET_ROLES_REQUEST:
            return {
                ...state,
                isGetRolesLoading: true,
                isGetRolesError: false,
                isGetRolesSuccess: false
            };
        case GET_ROLES_SUCCESS:
            return {
                ...state,
                getRolesResponse: getRolesResponse,
                isGetRolesLoading: false,
                isGetRolesError: false,
                isGetRolesSuccess: true,
            };
        case GET_ROLES_FAILURE:
            return {
                ...state,
                getRolesResponse: getRolesResponse,
                isGetRolesLoading: false,
                isGetRolesError: true,
                isGetRolesSuccess: false
            };       
        default:
            return state;
    }
};

export default rolesReducer;